import { Injectable } from "@angular/core";
const GOOGLE_MAPS_API_KEY = "AIzaSyCbECamVyEyEpBzrpNdk4wEp3tnl03RLng";
// Declearing a global variable
export type Maps = typeof google.maps;


@Injectable()
export class MapService {
    private mapsPromise: Promise<Maps> | null = null;

    load(): Promise<Maps> {
        // If Google Maps is already loaded, return immediately
        if ((window as any).google?.maps) {
            return Promise.resolve((window as any).google.maps);
        }

        // If loading is already in progress, return the same promise
        if (this.mapsPromise) {
            return this.mapsPromise;
        }

        // Otherwise, inject script and create new promise
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        const callbackName = `GooglePlaces_cb_${Date.now()}`;
        script.src = this.getScriptSrc(callbackName);

        const myWindow: any = window;

        this.mapsPromise = new Promise<Maps>((resolve, reject) => {
            myWindow[callbackName] = () => resolve((window as any).google.maps);
            script.onerror = reject;
        });

        document.body.appendChild(script);

        return this.mapsPromise;
    }

    private getScriptSrc(callback: string): string {
        const query = {
            v: "3",
            callback,
            key: GOOGLE_MAPS_API_KEY,
            libraries: "places",
            language: "en",
            region: "IN"
        };
        return `https://maps.googleapis.com/maps/api/js?${Object.keys(query)
            .map(k => `${k}=${query[k as keyof typeof query]}`)
            .join("&")}`;
    }

      maximizeMinimize() {
    const rippleSpan = document.querySelector(
      'button[mat-icon-button] span.mat-mdc-button-persistent-ripple'
    );
    rippleSpan?.classList.remove('mat-mdc-button-persistent-ripple');
  }
}
